import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, } from 'react';
import * as Styles from './styles';
export var ALERT_INTENT;
(function (ALERT_INTENT) {
    ALERT_INTENT["Info"] = "info";
    ALERT_INTENT["Success"] = "success";
    ALERT_INTENT["Error"] = "error";
    ALERT_INTENT["Warn"] = "warn";
})(ALERT_INTENT || (ALERT_INTENT = {}));
function renderDefaultIcon(intent) {
    return (_jsxs(Alert.Icon, { children: [intent === ALERT_INTENT.Success && _jsx(Alert.SuccessIcon, {}), intent === ALERT_INTENT.Warn && _jsx(Alert.WarnIcon, {}), intent === ALERT_INTENT.Info && _jsx(Alert.InfoIcon, {}), intent === ALERT_INTENT.Error && _jsx(Alert.ErrorIcon, {})] }));
}
export function Alert({ intent = ALERT_INTENT.Info, icon = renderDefaultIcon(intent), dismiss = null, children, ...rest }) {
    return (_jsxs(Styles.AlertWrapper, { "$intent": intent, "data-testid": `alert-${intent}`, ...rest, children: [icon && cloneElement(icon, { $intent: intent }), _jsx(Styles.AlertContent, { children: children }), dismiss && _jsx(Styles.AlertDismiss, { children: dismiss })] }));
}
export function AlertDismiss(props) {
    return (_jsx(Styles.AlertDismissButton, { ...props, children: _jsx(Styles.AlertDismissIcon, { "aria-hidden": true }) }));
}
Alert.SuccessIcon = Styles.SuccessIcon;
Alert.InfoIcon = Styles.InfoIcon;
Alert.WarnIcon = Styles.WarnIcon;
Alert.ErrorIcon = Styles.ErrorIcon;
Alert.Icon = Styles.AlertIcon;
Alert.Dismiss = AlertDismiss;
Alert.Title = Styles.AlertTitle;
Alert.Message = Styles.AlertMessage;
//# sourceMappingURL=index.js.map